import { NgModule } from '@angular/core';
import { CommonModule } from '@angular/common';
import { FormsModule, ReactiveFormsModule } from '@angular/forms';

import {MatButtonModule} from '@angular/material/button';
import {MatIconModule} from '@angular/material/icon';
import {MatInputModule} from '@angular/material/input';
import {MatFormFieldModule} from '@angular/material/form-field';
import {MatCheckboxModule} from '@angular/material/checkbox';
import {MatCardModule} from '@angular/material/card';
import { SharedModule } from 'src/app/components/shared.module';
import { HeaderComponent } from './header/header.component';
import { MatSelectModule } from '@angular/material/select';
import { MatSidenavModule } from '@angular/material/sidenav';
import { AutocompleteComponent } from './google-places/google-places.component';
import { MunicionRecomendadaComponent } from './municion-recomendada/municion-recomendada.component';
import { LanguageSelectorComponent } from './language-selector/language-selector.component';

@NgModule({
  declarations: [
    HeaderComponent,
    AutocompleteComponent,
    MunicionRecomendadaComponent,
    LanguageSelectorComponent
  ],
  imports: [
    CommonModule,
    FormsModule,
    ReactiveFormsModule,
    MatButtonModule,
    MatIconModule,
    MatInputModule,
    MatFormFieldModule,
    MatCheckboxModule,
    MatCardModule,
    SharedModule,
    MatSelectModule,
    MatSidenavModule
  ],
  exports: [
    HeaderComponent,
    AutocompleteComponent,
    MunicionRecomendadaComponent,
    LanguageSelectorComponent
  ]
})
export class ComponentsModule { }